import { render, staticRenderFns } from "./CreateCorruptionSection.vue?vue&type=template&id=7015a0c9&"
import script from "./CreateCorruptionSection.vue?vue&type=script&lang=js&"
export * from "./CreateCorruptionSection.vue?vue&type=script&lang=js&"
import style0 from "./CreateCorruptionSection.vue?vue&type=style&index=0&id=7015a0c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports